import React from 'react'

import { connect } from 'react-redux';

import { Card, CardBlock, CardTitle , Button} from 'reactstrap';

import ReactTable from "react-table";
import "react-table/react-table.css";

import * as actions from  '../../actions/eventos';

import {api} from '../../actions/_request';

import Modal from './formEvento.js'

import IconEdit from 'react-icons/lib/md/edit';

import swal from 'sweetalert2'

class InventarioFisico extends React.Component{
	constructor(props) {
        super(props);
        this.state = {
          modal : false,
	        data: [],
        };

      this.toggle = this.toggle.bind(this);
    }

  componentDidMount(){
    this.props.get();
  }

  toggle(evt, prospectoid = null, title = "Agregar Evento")
    {
        let {modal} = this.state;

        this.setState({
            modal       : !modal,
            prospectoid : prospectoid,
            title       : title,
            
        });
    }


    render(){
    	let {data} = this.props.eventos;

    	return(

    		<div className="view">
                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 text-uppercase">Eventos</h1>
                    </header>
                </div>
           		<div className="view-content view-components">
                    <Card>
                        <CardBlock>
                          <div className="text-right">
                            <Button color="success" className="mb-2" onClick={this.toggle}>
                                {"+"}&nbsp;Agregar
                            </Button>
                          </div>
                            <ReactTable
                              getTrProps={(state, rowInfo, column) => {
                                  
                                  if(rowInfo === undefined){
                                          
                                          return{

                                          }
                                        }else{
                                           return{
                                            onDoubleClick: (evt)=>this.toggle(evt, rowInfo.original.id, 'Editar Evento')
                                        } 
                                  
                                    }
                              }}
                             
                              className = "-striped -highlight"
                              columns   = {[
                               
                                {Header: 'Titulo', accessor: 'titulo' },
                                {Header: 'Expositor', accessor: 'expositor'},
                                {Header: 'Fecha', accessor: 'fecha_evento'},
                                {Header: 'Horario', accessor: 'horario' },
                                {
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                    maxWidth:150,
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-right">
                                                <Button
                                                 color="success" 
                                                 className="btn-sm" 
                                                 onClick={(evt)=>this.toggle(evt, row.original.id, 'Editar Evento')}>
                                                    <IconEdit />
                                                </Button>{' '}
                                            </div>
                                        )
                                    }
                                }
                              
                              ]}

                              data={data}
                              filterable
                              defaultPageSize={10} 
                             
                            />
                        </CardBlock>
                    </Card>
                </div>
                {
                   this.state.modal&& 
                   <Modal
                 open={this.state.modal} 
                 toggle={this.toggle} 
                 title={this.state.title} 
                 prospectoid={this.state.prospectoid}
                 
                />
                }

            </div>

    	)
    }
}

function mapStateToProps(state, ownProps) {
    return {
        eventos : state.eventos,
    }
};

export default connect(mapStateToProps, actions)(InventarioFisico)


// WEBPACK FOOTER //
// ./src/views/eventos/index.js